import * as types from '../actions/actionTypes';

const initialState = {
  receiptUrl: ""
};

export default function (state = initialState, action) {

  switch (action.type) {

    case types.SET_RECEIPT_URL:
      return Object.assign({}, state, {
        ...action.payload
      });
  }

  return state;

}
